import React from "react";
import { Link, Redirect } from "react-router-dom";
import { useProductsContext } from "./products.context";
import useQueryParams from "../../hooks/useQueryParams";

const colors = {
  Rosewood: "#65000B",
  Teak: "#B1946C",
  Walnut: "#5D4C3A",
  Sapele: "#59261F",
  White: "#FFFFFF",
  Oak: "#806517",
  Maple: "#DEB887",
  Raw: "#E0D0B7",
  Redgum: "#B3272C",
  Cedar: "#3B4249",
};

const NoProductsFound = () => {
  const { products, isLoadingProducts } = useProductsContext();
  const { params } = useQueryParams();
  if (isLoadingProducts || products.length > 0) return null;
  return (
    <div>
      <h2>No products found</h2>

      <p style={{ color: "#666" }}>
        {params.search && (
          <span>
            We couldn't find anything for <strong>"{params.search}"</strong>
          </span>
        )}
      </p>
    </div>
  );
};

const ProductsList = () => {
  const { products } = useProductsContext();
  return (
    <div className="grid-x grid-margin-x shop-products-list">
      {products.map((product) => {
        return (
          <div
            className="shop-products-card cell small-12 medium-4 large-3 flex-container flex-dir-column"
            key={product.id}
          >
            <div className="shop-products-card-media" style={{ backgroundColor: colors[product.colour] }}>
              {product.images?.[0]?.woocommerce_thumbnail ? (
                <img
                  src={product.images[0].woocommerce_thumbnail}
                  alt={product.name}
                  className="shop-products-card-image"
                />
              ) : (
                <div className="shop-products-card-no-image" />
              )}
            </div>
            <div className="shop-products-card-content flex-child-grow align-justify">
              <div className="details-section">
                <div className="id-text">
                  <span>{product.sku} </span>
                </div>
                <div className="custom-text" title={product.name}>
                  <span> {product.name} </span>
                </div>
                <div className="original-text">{product.name}</div>
              </div>
              <Link to={`/product/${product.id}`}>
                <button type="button" className="button">
                  View
                </button>
              </Link>
            </div>
          </div>
        );
      })}
      <div className="cell small-12 medium-12 large-12">
        <NoProductsFound />
      </div>
    </div>
  );
};

export default ProductsList;
